type NativePressEvent = KeyboardEvent | MouseEvent;

const isKeyboardEvent = (e: NativePressEvent): e is KeyboardEvent => {
  return e instanceof KeyboardEvent;
};
const isMouseEvent = (e: NativePressEvent): e is MouseEvent => {
  return e instanceof MouseEvent;
};

export { isKeyboardEvent, isMouseEvent };
export type { NativePressEvent };
